import React, { FC, ReactNode } from 'react';
import s from './Modal.module.scss';

type HeaderProps = {
  children: ReactNode;
};

const Header: FC<HeaderProps> = ({ children }) => (
  <div className={s.header}>
    {children}
  </div>
);

export default Header;
